import { useMemo } from 'react';
import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller/src/components/first-activation-date-ms/index.tsx';
import { isWithinLast14Days } from '../is-within-last-14-days/index.tsx';

// Only runs the comparison once during the component's lifecycle.
export const useIsFirstActivationDateWithinLast14DaysMemo = () => {
	const firstActivationDate = useFirstActivationDateMs();
	return useMemo(() => isWithinLast14Days(firstActivationDate), [firstActivationDate]);
};
